<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';
import {
  CollapsibleTrigger,
  type CollapsibleTriggerProps,
  useForwardProps
} from 'radix-vue';

import { createDelegatedProps } from '@/lib/helpers';
import { cn } from '@/lib/utils';

interface CustomCollapsibleTriggerProps extends CollapsibleTriggerProps {
  class?: HTMLAttributes['class'];
  testId?: string;
}

const props = withDefaults(defineProps<CustomCollapsibleTriggerProps>(), {
  testId: "collapsible"
});

const delegatedProps = computed(() =>
  createDelegatedProps<typeof props>(props)
);

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <CollapsibleTrigger
    v-bind="forwardedProps"
    :data-testid="`${props.testId}-trigger`"
    :class="cn('hover:bg-transparent dark:hover:bg-transparent', props.class)"
  >
    <slot />
  </CollapsibleTrigger>
</template>
